angular.module('app').component('owTachograph', {
    templateUrl: 'js/components/ow-tachograph/index.html?cache=4',
    require: {
        $ow: '^^objectWindow',
    },
    controller: OWTachographController,
    controllerAs: '$uth',
});

OWTachographController.$inject = [
    '$scope',
    '$q',
    '$http',
    '$translate',
    '$ngConfirm',
    'toaster',
    '$timeout',
    '$window',
];

function OWTachographController($scope, $q, $http, $translate, $ngConfirm, toaster, $timeout, $window) {
    var $ctrl = this;

    $ctrl.$onInit = function() {
        $ctrl.$ow.childs.push(this);

        load($ctrl.$ow.object);
    };

    $ctrl.$onDestroy = function() {
        $ctrl.$ow.childs = $ctrl.$ow.childs.filter(function(o) {
            return !(o instanceof $ctrl.constructor);
        });
    };

    $ctrl.onObjectDataChanged = function() {
        if (!$ctrl.$ow.object || !$ctrl.$ow.object.has.tachograph) {
            return;
        }

        reload(moment());
    };

    $ctrl.onObjectChanged = function() {
        if (!$ctrl.$ow.object || !$ctrl.$ow.object.has.tachograph) {
            return;
        }

        var id = $ctrl.$ow.object.id;
        var start = moment()
            .startOf('day')
            .format('YYYY-MM-DD HH:mm:ss');

        var end = moment()
            .endOf('day')
            .format('YYYY-MM-DD HH:mm:ss');

        loadTachographCards(id, start, end).then(
            function(data) {
                if (data.length > 0) {
                    $ctrl.card = data[0].TachoDriverId;
                }

                var now = moment();
                reload(now);
            },
            function() {}
        );
    };

    var analitycsTranslation = 'objects.market-window.analitycs.times.';

    function getMomentRelativeTime(short, quantity) {
        var times = moment().localeData()._relativeTime;
        if (typeof times[short] === 'function') {
            return times[short](quantity, true, short);
        }
        return times[short].replace('%d', quantity);
    }

    var loadTachographCards = function(id, start, end) {
        return $q(function(resolve, reject) {
            var endpoint = '/api/node/object/tachograph-drivers-all';
            endpoint += '?object=' + id + '&start=' + start + '&end=' + end;

            return $http.get(endpoint).then(function(response) {
                $ctrl.cards = response.data.data;
                return resolve($ctrl.cards);
            }, reject);
        });
    };

    $ctrl.cards = false;
    $ctrl.card = null;

    $ctrl.tachograph = {
        analyze: {
            constantly: {
                verification: getMomentRelativeTime('hh', 4) + ' ' + getMomentRelativeTime('mm', 30),
                type: 'hours',
            },
            daily: {
                verification: getMomentRelativeTime('hh', 24),
                type: 'hours',
            },
            moreThan9Hours: {
                verification:
                    '> ' +
                    getMomentRelativeTime('hh', 9) +
                    ' - ' +
                    $translate.instant(analitycsTranslation + 'days-unit'),
                type: 'days',
            },
            weekly: {
                verification: $translate.instant(analitycsTranslation + 'week'),
                type: 'hours',
            },
            twoWeeks: {
                verification: $translate.instant(analitycsTranslation + 'two-weeks'),
                type: 'hours',
            },
            daysInWeek: {
                verification: $translate.instant(analitycsTranslation + 'days-by-week'),
                type: 'days',
            },
        },
        data: false,
        summary: false,
        history: moment(),
    };

    $ctrl.getTachographSummaryValue = function(type) {
        return $ctrl.tachograph.summary[type];
    };

    var reload = function(date) {
        date.endOf('day');
        $ctrl.tachograph.history = moment(date);

        load($ctrl.$ow.object);
    };

    $ctrl.onDateChange = function(n) {
        var changed = n.format('YYYY-MM-DD HH:mm') !== $ctrl.tachograph.history.format('YYYY-MM-DD HH:mm');

        if (n && $ctrl.tachograph.history && changed) {
            $ctrl.tachograph.history = moment(n);

            load($ctrl.$ow.object);
        }
    };

    $ctrl.onCardChange = function() {
        if ($ctrl.card) {
            load($ctrl.$ow.object);
        }
    };

    $ctrl.twoWeeksCharts = [];

    var loadTwoWeeksCharts = function() {
        $ctrl.twoWeeksCharts = [];

        loadTwoWeeks($ctrl.$ow.object, true).then(function(data) {
            $ctrl.twoWeeksCharts = data.chart;
            $ctrl.isTwoWeeksChartReady = true;

            $timeout(function() {
                $window.dispatchEvent(new Event('resize'));
            }, 500);
        });
    };

    var loadTwoWeeks = function(object, graph) {
        var date = moment($ctrl.tachograph.history);
        date = date.format('YYYY-MM-DD HH:mm:ss');

        var card = $ctrl.card ? $ctrl.card : false;
        var endpoint = '/api/object/' + object.id + '/analysis';

        var parameters = {
            date: date,
        };
        if (card) {
            parameters.card = card;
        }
        if (graph) {
            parameters.graph = true;
        }

        return $http.get(endpoint, { params: parameters }).then(
            function(response) {
                var data = response.data.data;
                return data === void 0 ? [] : data;
            },
            function() {
                return [];
            }
        );
    };

    $ctrl.loadTwoWeeksCharts = loadTwoWeeksCharts;

    var chartAPICache = {
        cache: false,
        params: {
            card: false,
            date: false,
        },
        data: false,
        time: moment()
    };

    var load = function(object) {
        var date = moment($ctrl.tachograph.history);
        date = date.format('YYYY-MM-DD HH:mm:ss');

        var card = $ctrl.card ? $ctrl.card : false;

        if (chartAPICache.params.card !== card) {
            chartAPICache.cache = false;
        }

        if (chartAPICache.params.date !== date) {
            chartAPICache.cache = false;
        }

        var duration = Math.round(moment.duration(moment().diff(chartAPICache.time)).asSeconds());

        if (duration >= 120) {
            chartAPICache.cache = false;
        }

        if (chartAPICache.cache) {
            parse(chartAPICache.data);
            return true;
        }

        var endpoint = '/api/object/' + object.id + '/chart';

        var parameters = {
            date: date,
        };

        if (card) {
            parameters.card = card;
        }

        if (!chartAPICache.cache) {
            parameters.graph = true;
        }

        function parse(result) {
            $ctrl.$ow.tachograph = result;

            $ctrl.daily = result.day;
            $ctrl.tachograph.chart = result.chart;

            var summary = angular.copy(result.summary);
            ['rest', 'work', 'drive', 'duty'].map(function(k) {
                summary[k] = moment()
                    .startOf('day')
                    .seconds(summary[k])
                    .format('HH:mm');
            });

            $ctrl.tachograph.summary = summary;
        }

        $http.get(endpoint, { params: parameters }).then(function(response) {
            var result = response.data.data;

            chartAPICache.data = result;
            parse(result);

            chartAPICache.cache = true;
            chartAPICache.time = moment();

            chartAPICache.params.card = card;
            chartAPICache.params.date = date;
        });
    };

    $ctrl.showAnalyticsModal = function(object) {
        loadTwoWeeks(object, false).then(function(data) {
            var summary = data.summary;

            if (!summary) {
                toaster.pop(
                    'error',
                    $translate.instant('general.toastr.error.header'),
                    $translate.instant('general.no-results')
                );
                return false;
            }

            var keys = Object.keys(summary);
            var types = ['now', 'max', 'left', 'rest'];

            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                var item = summary[key];
                var mapper = $ctrl.tachograph.analyze[key];

                mapper.original = Object.assign({}, item);
                mapper.original.percentage = Math.round((item.now / item.max) * 100);

                for (var j = 0; j < types.length; j++) {
                    var type = types[j];
                    if (item[type] === void 0) {
                        continue;
                    }

                    if (mapper.type === 'hours') {
                        var duration = moment.duration(item[type], 'seconds');
                        var hours = Math.floor(duration.asHours());
                        var mins = Math.floor(duration.asMinutes()) - hours * 60;

                        hours = hours < 10 ? '0' + String(hours) : hours;
                        mins = mins < 10 ? '0' + String(mins) : mins;

                        item[type] = hours + ':' + mins;
                    } else {
                        item[type] = getMomentRelativeTime('dd', item[type]);
                    }
                }
                $ctrl.tachograph.analyze[key] = Object.assign(mapper, item);
            }

            $ngConfirm({
                title: $translate.instant('objects.market-window.tachograph.analitycs'),
                contentUrl: 'js/components/ow-tachograph/modals/analytics.html',
                animation: 'rotate',
                columnClass: 'medium',
                icon: 'pe-7s-id pe-lg pe-va',
                scope: $scope,
                buttons: {
                    yes: {
                        text: $translate.instant('general.form.submit'),
                        btnClass: 'btn-dark',
                        action: function() {
                            return true;
                        },
                    },
                },
            });

            return true;
        });
    };

    var isChartModalOpened = false;
    $ctrl.isTwoWeeksChartReady = false;

    $ctrl.showChartModal = function() {
        isChartModalOpened = true;
        $ctrl.isTwoWeeksChartReady = false;

        load($ctrl.$ow.object);

        $ngConfirm({
            title: $translate.instant('objects.market-window.tachograph.chart'),
            contentUrl: 'js/components/ow-tachograph/modals/chart.html',
            columnClass: 'xlarge',
            icon: 'pe-7s-graph2 pe-lg pe-va',
            scope: $scope,
            buttons: {
                yes: {
                    text: $translate.instant('general.form.submit'),
                    btnClass: 'btn-dark',
                    action: function() {
                        isChartModalOpened = false;
                        return true;
                    },
                },
            },
        });
    };
}
